<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <div class='flex md12 sm6 xs12'>
            <va-input
              v-model='insertData.id'
              v-show="showId"
              label='id'
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.name"
              label="面经题目"
              removable
              :messages="message"
              :error="!!error.nameErrors.length"
              :error-messages="error.nameErrors"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-select
              v-model="insertData.organization"
              label="企业名称"
              single
              :messages="message"
              :error="!!error.organizationErrors.length"
              :error-messages="error.organizationErrors"
              :options="organizations.map(x=>x.name)"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-select
              v-model="insertData.positionTag"
              label="岗位标签"
              single
              :messages="message"
              :error="!!error.positionTagErrors.length"
              :error-messages="error.positionTagErrors"
              :options="positionTags.map(x=>x.name)"
              :onchange="handlePositionTagIdChange"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-select
              v-model="insertData.questionTags"
              label="题目类型"
              multiple
              :messages="message"
              :error="!!error.questionTagsErrors.length"
              :error-messages="error.questionTagsErrors"
              :options="questionTags.map(x=>x.name)"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <vue-trix
              v-model="insertData.content"
              placeholder="面经内容"
              :config="captionConfig"
              @trix-attachment-add="handleAttachmentChanges"
            ></vue-trix>
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.sortNum"
              label="排序"
              placeholder="数字越小越靠前"
              removable
              type="number"
              oninput="if(value <0)value=1"
              :min="1"
              :messages="message"
              :error="!!error.sortNumErrors.length"
              :error-messages="error.sortNumErrors"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-select
              v-model="insertData.status"
              label="发布状态"
              single
              :messages="message"
              :error="!!error.statusErrors.length"
              :error-messages="error.statusErrors"
              :options="statusOptions"
            />
          </div>
        </div>

        <div class="flex md2 offset--md5">
          <va-button class="ma-0" color="primary" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
            submit
          </va-button>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import { copyObject } from '../../utils/common'
import uploadApi from '../../api/upload'
import organizationApi from '../../api/interview/organization'
import interviewQuestionApi from '../../api/interview/interviewQuestion'
import { STATUS_OPTIONS, TAG_TYPE } from '../../utils/constants'
import positionTagApi from '../../api/interview/positionTag'
import questionTagApi from "../../api/interview/questionTag";

export default {
  data () {
    return {
      insertData: {
        id: null,
        name: '',
        content: '',
        sortNum: null,
        createdAt: '',
        questionTagIds: [],
        questionTags: [],
        positionTagId: null,
        positionTag: null,
        organization: '',
        organizationId: null,
        status: null,
      },
      message: ['Required field'],
      error: {
        nameErrors: [],
        sortNumErrors: [],
        positionTagErrors: [],
        questionTagsErrors: [],
        statusErrors: [],
        organizationErrors: [],
      },
      showId: false,
      title: '创建面经',
      submitButtonStatus: true,
      statusOptions: STATUS_OPTIONS.map(x => x.TEXT),
      positionTags: [],
      questionTags: [],
      organizations: [],
      captionConfig: {
        attachments: {
          preview: {
            caption: {
              name: false,
              size: false,
            },
          },
        },
      },
    }
  },
  created () {
    this.getInterviewQuestion()
    this.listOrganization()
    this.listPositionTag()
    this.listQuestionTag()
  },
  computed: {
    formReady () {
      return !this.error.nameErrors.length &&
          !this.error.sortNumErrors.length &&
          !this.error.organizationErrors.length &&
          !this.error.positionTagErrors.length &&
          !this.error.questionTagsErrors.length &&
          !this.error.statusErrors.length
    },
    flipOrganization () {
      const flipTags = {}
      this.organizations.forEach(x => {
        flipTags[x.name] = x.id
      })
      return flipTags
    },
    flipPositionTag () {
      const flipTags = {}
      this.positionTags.forEach(x => {
        flipTags[x.name] = x.id
      })
      return flipTags
    },
    flipQuestionTags () {
      const flipTags = {}
      this.questionTags.forEach(x => {
        flipTags[x.name] = x.id
      })
      return flipTags
    },
    handlePositionTagIdChange() {
      this.listQuestionTag()
    },
  },
  methods: {
    getInterviewQuestion () {
      const params = this.$route.params
      if (params.id != null) {
        this.showId = true
        this.title = '编辑面经'
        // 通过id获取详情
        interviewQuestionApi.getInterviewQuestion(params.id).then(response => {
          copyObject(response.interviewQuestion, this.insertData)
          this.listQuestionTag()
          STATUS_OPTIONS.forEach(x => {
            if (x.CODE === response.interviewQuestion.status) {
              this.insertData.status = x.TEXT
            }
          })
        }).catch(error => {
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    listPositionTag () {
      const params = {
        type: TAG_TYPE.POSITION_TAG.CODE,
      }
      positionTagApi.listPositionTag(params).then(response => {
        this.positionTags = response.tags
      }).catch(error => alert(error.msg))
    },
    listQuestionTag () {
      const params = {
        type: TAG_TYPE.QUESTION_TAG.CODE,
        positionTagId: this.flipPositionTag[this.insertData.positionTag],
      }
      questionTagApi.listQuestionTag(params).then(response => {
        this.questionTags = response.tags
      }).catch(error => alert(error.msg))
    },
    listOrganization () {
      const params = {}
      organizationApi.listOrganization(params).then(response => {
        this.organizations = response.organizations
      }).catch(error => alert(error.msg))
    },
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      this.changeButtonStatus(false)
      const data = {
        name: this.insertData.name,
        content: this.insertData.content,
        positionTagId: null,
        questionTagIds: [],
        organizationId: null,
        status: null,
        sortNum: this.insertData.sortNum !== null ? this.insertData.sortNum : 1,
      }
      data.organizationId = this.flipOrganization[this.insertData.organization]
      data.positionTagId = this.flipPositionTag[this.insertData.positionTag]
      data.questionTagIds = this.insertData.questionTags.map(x => {
        return this.flipQuestionTags[x]
      }).filter(Boolean)
      STATUS_OPTIONS.forEach(x => {
        if (x.TEXT === this.insertData.status) {
          data.status = x.CODE
        }
      })

      if (this.insertData.id != null) {
        data.id = this.insertData.id
        interviewQuestionApi.updateInterviewQuestion(data.id, data).then(response => {
          if (response.success === true) {
            this.showToast('面经更新成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listInterviewQuestion' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      } else {
        interviewQuestionApi.saveInterviewQuestion(data).then(response => {
          if (response.success === true) {
            this.showToast('添加面经成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listInterviewQuestion' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    clickCancel () {
    },
    checkField () {
      this.error.nameErrors = this.insertData.name ? [] : ['name is required']
      this.error.organizationErrors = this.insertData.organization ? [] : ['organization is required']
      this.error.sortNumErrors = this.insertData.sortNum ? [] : ['sortNum is required']
      this.error.positionTagErrors = this.insertData.positionTag ? [] : ['positionTag is required']
      this.error.questionTagsErrors = this.insertData.questionTags ? [] : ['questionTags is required']
      this.error.statusErrors = this.insertData.status ? [] : ['status is required']
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
    handleAttachmentChanges (event) {
      const file = event.attachment.file
      const formData = new FormData()
      formData.append('type', 'IMAGE')
      formData.append('file', file)
      uploadApi.uploadImage(formData).then(response => {
        event.attachment.setAttributes({ url: response.url })
      }).catch(error => {
        console.log(error)
      })
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
